import {
    put,
    call,
    select,
    takeEvery,
    takeLatest
} from 'redux-saga/effects';

import { getPreferredCurrencyCode } from '../currency/currencyUtils';
import { getPreferredProgramCode } from '../program/programUtils';
import { getActiveProgramCode } from '../program/programSelectors';
import { SET_PROGRAM_CODE, clearProgram } from '../program/programModule';
import { SET_CART_STATUS, CART_STATUS } from '../cart/cartModule';

import {
    getCartPath,
    getErrorNoRetryPath,
    getConfirmationPath,
    APP_ERROR_TYPES
} from './flow';
import {
    flowParamsUpdated,
    setPreferredCurrency,
    setPreferredProgram,
    removePreferredProgram,
    RESTART_BUY_FLOW,
    SHOW_APP_ERROR,
    ORDER_COMPLETE
} from './flowModule';
import { getHomePath } from './flowSelectors';
import {
    getURLSearchParams,
    push,
    removeQueryParams,
    replace,
    updateSearch
} from './routing';
import { LOCATION_CHANGE } from './routingModule';



export function* updateProgramCode({ programCode }) {
    const urlParams = yield call(getURLSearchParams);
    const urlProgramCode = yield call([urlParams, urlParams.get], 'programCode');
    if (programCode) {
        if (urlProgramCode !== programCode) {
            yield call(updateSearch, { programCode });
        }
    } else if (urlProgramCode !== null) {
        yield call(removeQueryParams, ['programCode']);
    }
    if (!programCode) {
        yield put(removePreferredProgram());
    }
}


export function* updateQueryParams() {
    
    
    
    
    const programCode = yield select(getActiveProgramCode);
    yield call(updateProgramCode, { programCode });
    yield put(flowParamsUpdated());
}


export function* updateCartStatus({ status }) {
    
    if (status === CART_STATUS.PROCESSING || status === CART_STATUS.READY) {
        yield call(push, ({ pathname: getCartPath() }));
    }
}


export function* restartBuyFlow() {
    const homePath = yield select(getHomePath);
    yield put(clearProgram());
    yield call(push, ({ pathname: homePath }));
}


export function* showAppError({ errorType }) {
    if (errorType === APP_ERROR_TYPES.NO_RETRY) {
        yield call(replace, { pathname: getErrorNoRetryPath() });
    }
}


export function* completeBuyFlow({ orderDetails }) {
    
    
    
    const location = {
        pathname: getConfirmationPath(),
        state: orderDetails,
        search: window.location.search
    };
    yield call(replace, location);
}


export function* initializeFlow() {
    
    

    const preferredCurrencyCode = yield call(getPreferredCurrencyCode);
    const preferredProgramCode = yield call(getPreferredProgramCode);
    if (preferredCurrencyCode) {
        yield put(setPreferredCurrency(preferredCurrencyCode));
        yield call(removeQueryParams, ['currencyCode', 'currency_code']);
    }
    yield put(setPreferredProgram(preferredProgramCode));
}

export function* flowSagasWatcher() {
    yield takeEvery(LOCATION_CHANGE, updateQueryParams);
    yield takeEvery(SET_PROGRAM_CODE, updateProgramCode);
    yield takeLatest(SET_CART_STATUS, updateCartStatus);
    yield takeLatest(RESTART_BUY_FLOW, restartBuyFlow);
    yield takeLatest(ORDER_COMPLETE, completeBuyFlow);
    yield takeLatest(SHOW_APP_ERROR, showAppError);
}
